export const kr = {
  // 랜딩 페이지 히어로 섹션
  hero: {
    title: '쓸수록 득이 되는,\n똑똑한 카드 생활',
    appStore: 'App Store',
    googlePlay: 'Google Play',
    logoTitle: '카득'
  },

  // Circle 섹션
  circle: {
    title: '카드는 많은데, 혜택은 놓치고 있다면?'
  },

  // Benefits 섹션
  benefits: {
    title: {
      desktop: '잠재된 내 카드의 혜택을 최대로 활용할 수 있도록',
      tablet: '잠재된 내 카드의 혜택을\n최대로 활용할 수 있도록'
    },
    subtitle: {
      desktop: '카득은 내 카드를 효율적으로 관리하고 혜택을 찾아 누릴 수 있도록 도와줍니다',
      mobile: '카득은 내 카드를 효율적으로 관리하고\n혜택을 찾아 누릴 수 있도록 도와줍니다'
    },
    cards: [
      {
        title: '맞춤 카드 추천',
        text: {
          desktop: '어디서든, 어떤 카드가 최적의 카드인지\n카득이 바로 추천해 드려요',
          mobile: '어디서든, 어떤 카드가 최적의 카드인지 카득이 바로 추천해 드려요'
        }
      },
      {
        title: '카드 혜택 극대화',
        text: {
          desktop: '적립, 할인 등 다양한 혜택을\n자동으로 최적화해 추천해 드려요',
          mobile: '적립, 할인 등 다양한 혜택을 자동으로 최적화해 추천해 드려요'
        }
      },
      {
        title: '똑똑한 소비 습관 형성',
        text: {
          desktop: '카드를 쓰기 전부터 혜택을 챙기는\n똑똑한 소비 습관을 만들어요',
          mobile: '카드를 쓰기 전부터 혜택을 챙기는 똑똑한 소비 습관을 만들어요'
        }
      },
      {
        title: '고객의 정보를 소중하게',
        text: {
          desktop: '너무 많은 정보에 동의하지 않아도\n카드 혜택을 관리할 수 있어요',
          mobile: '너무 많은 정보에 동의하지 않아도 카드 혜택을 관리할 수 있어요'
        }
      }
    ]
  },

  // Reviews 섹션
  reviews: {
    title: '카득 사용 후기',
    cards: [
      {
        text: "마트 갈 때마다 무슨 카드 써야 할인받는지\n매번 검색하느라 번거로웠어요. 그런데 카득은\n매장 검색하면 '이 카드 쓰세요' 하고 알려주니까,\n이제는 결제할 때 망설임이 없어요.\n육아 때문에 정신없는데 이건 진짜\n'머리 안 써도 되는 서비스'라 너무 고마워요.",
        author: '이*진 36세 | 워킹맘 | 카드 사용 개수: 4장'
      },
      {
        text: "카드 관리 앱들 많이 써봤어요. 근데 다들\n포인트, 실적 같은 숫자만 보여주지\n'어떤 카드 써야 좋은지'는 알려주지는 않더라고요.\n카득은 카드를 사용할 장소에서 추천카드를\n알려주는 게 진짜 편리해요. 심지어 마이데이터\n연결도 안 해도 되니까 부담도 없어요.\n출장 많고 카드 많으면 진짜 써봐야\n이게 얼마나 편한지 알아요.",
        author: '최*나 39세 | 프리랜서 | 카드 사용 개수: 5장'
      },
      {
        text: "카득 쓰기 전에는 카드 쓸 때 그냥\n(혜택 좋은 카드를)기억에 의존해 사용했었는데,\n근데 알고 보니 매번 혜택 다 놓치고 있었던 거예요.\n카득을 사용한 이후로 무의식적인 소비가\n'계획 소비'로 바뀐 느낌이에요.\n내가 나를 컨트롤하는 기분이랄까.\n이왕 소비하는 거 한두푼이라도 아끼고 싶다는\n마음이 컸는데 절약에 실질적인 도움이 됐어요.",
        author: '박*영 29세 | 중소기업 대리 | 카드 사용 개수: 3장'
      }
    ]
  },

  // QAs 섹션
  qas: {
    title: '카득 Q&A',
    cards: [
      {
        question: '카득은 어떻게 사용하나요?',
        answer: 'SNS 회원가입 후 소지한 카드의 종류를 등록하면,',
        boldAnswer: '\n목적지 검색 또는 지도에서 매장을 선택하여 최적의 카드를 추천받을 수 있습니다.'
      },
      {
        question: {
          desktop: '더 많은 매장의 카드 혜택을 확인하고 싶어요',
          mobile: '더 많은 매장의 카드 혜택을 확인하고 싶어요'
        },
        answer: '프랜차이즈부터 동네 맛집까지,\n더 많은 매장이 등록될 수 있도록 준비하고 있습니다.'
      },
      {
        question: '마이데이터 연동이 꼭 필요한가요?',
        answer: '아니요, ',
        boldAnswer: '마이데이터 연동 없이도',
        answer2: '\n카드 등록 및 관리를 간편하게 할 수 있습니다.'
      },
      {
        question: '소지한 카드를 검색할 수 없어요.',
        answer: {
          desktop:
            '현재 발급 가능한 카드가 우선적으로 등록하실 수 있으며,\n발급이 종단된 카드는 고객 요청 시 등록해 드리고 있습니다.',
          tablet:
            '현재 발급 가능한 카드가 우선적으로\n 등록하실 수 있으며,발급이 종단된 카드는\n 고객 요청 시 등록해 드리고 있습니다.'
        }
      }
    ]
  },

  // 서비스 종료 안내 모달
  closureNotice: {
    title: '카득 서비스 종료 안내',
    greeting: '안녕하세요, 카득(CARDEUK) 입니다.',
    intro:
      '여러분 스마트한 카드 생활에 조금이나마 도움이 되고자 시작했던 카득이 2026년 10월 23일(금)을 마지막으로 서비스를 잠정 종료하게 되었습니다.\n더 오랫동안 함께하지 못해 아쉬운 마음이 크지만, 그동안 카득을 찾아주시고 이용해 주신 모든 분들께 진심으로 감사드립니다.',
    detailTitle: '서비스 종료 및 개인정보 삭제 안내',
    details: [
      {label: '서비스 종료일', value: '2026년 10월 23일'},
      {label: '종료 대상', value: '카득 앱 및 관련 서비스'},
      {label: '개인정보 삭제일', value: '2026년 10월 23일'}
    ],
    privacy:
      '서비스 종료 후 보유 중인 개인정보는 개인정보처리방침에 따라 2026년 10월 23일에 모두 삭제될 예정입니다.\n단, 관계 법령에 따라 보존 의무가 있는 정보는 해당 법령에서 정한 기간 동안 별도 보관 후 삭제됩니다.',
    outro:
      '카득과 함께해 주신 시간에 감사드리며, 더 좋은 혜택을 드리는 서비스로 다시 한번 여러분께 찾아올 수 있길 소망하며, 늘 행복이 가득하시길 바랍니다.',
    signature: '카득 운영팀 올림',
    close: '확인'
  },

  // Footer 섹션
  footer: {
    company: '주식회사 소금광산 대표이사',
    ceo: '유창현',
    businessNumber: '873-86-01911',
    businessNumberLabel: '사업자등록번호',
    headOffice: '(12902) 경기도 하남시 미사강변한강로 177, 3층 하남스타트업캠퍼스 7호',
    headOfficeLabel: '본사주소',
    researchOffice: '(31145) 충남 천안시 서북구 천안천4길 32, 그린스타트업타운 501호',
    researchOfficeLabel: '연구소 주소',
    contact: '070-7799-7410',
    contactLabel: '연락처',
    copyright: '© 2023. SALTMiNE, Inc. all rights reserved.',
    logoAlt: '소금광산 로고'
  },

  register: {
    required: {
      identifier: '올바른 아이디를 입력해주세요.',
      password: '비밀번호를 입력해주세요.',
      passwordConfirm: '비밀번호를 재입력해주세요.',
      name: '이름을 입력해주세요.',
      nickname: '올바른 닉네임을 입력해주세요.',
      birthDate: '생년월일을 입력해주세요.',
      phoneNumber: '휴대전화번호를 입력해주세요.',
      email: '이메일을 입력해주세요.',
      inputVerifyNumber: '인증번호를 입력해주세요.'
    },

    pattern: {
      identifier: '영문과 숫자만 입력입력해주세요.',
      password:
        '영문 대문자+소문자+숫자+특수문자 ‘@&!%*?&’ 4가지 이상을 조합하여 최소 8자리 이상을 입력해 주세요.',
      name: '올바른 이름을 입력해주세요.',
      nickname: '올바른 닉네임을 입력해주세요.',
      phoneNumber: '올바른 번호를 입력해주세요.',
      birthDate: '올바른 생년월일 형식(YYYY-MM-DD)이 아닙니다.',
      email: '올바른 이메일을 입력해주세요.'
    },
    maxLength: {
      identifier: '최대 20글자까지 입력가능합니다.',
      name: '이름은 최대 10글자까지 가능합니다.'
    },
    placeholder: {
      identifier: '아이디',
      password: '비밀번호 입력',
      passwordConfirm: '비밀번호 중복확인',
      phoneNumber: '휴대전화번호 입력',
      name: '이름',
      nickname: '닉네임',
      birthDate: '생년월일(YYYY,MM,DD) 숫자만 입력해주세요.',
      email: '이메일',
      inputVerifyNumber: '인증번호 입력'
    }
  },
  profileChange: {
    placeholder: {
      oldPassword: '현재 비밀번호 입력',
      newPassword: '새로운 비밀번호 입력',
      newPasswordConfirm: '새로운 비밀번호 재입력',
      name: '이름',
      nickname: '닉네임',
      birthDate: '생년월일(YYYY,MM,DD) 숫자만 입력해주세요.',
      email: '이메일'
    }
  }
};
